import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BsCheck } from "react-icons/bs";
import "./Receipt.css";

export default function ReceiptPage() {
  const { id } = useParams();
  const [orderDetails, setOrderDetails] = useState(null);

  // ✅ Fetch order details
  useEffect(() => {
    axios
      .get(`https://admin-aged-field-2794.fly.dev/orders/${id}`)
      .then((res) => setOrderDetails(res.data))
      .catch((err) => console.error(err));
  }, [id]);

  useEffect(() => {
    if (orderDetails) {
      setTimeout(() => {
        window.print();
      }, 100);
    }
  }, [orderDetails]);

  if (!orderDetails) return <p className="view-loading">Loading...</p>;

  const tokenNo = orderDetails.token_number ?? orderDetails.id.slice(0, 4);
  const createdAt = new Date(orderDetails.created_datetime).toLocaleString(
    "en-IN",
    { hour12: true, timeZone: "Asia/Kolkata" }
  );

  const {
    cgst = 0,
    sgst = 0,
    total_gst = 0,
    round_off = 0,
    total_amount = 0,
    order_details = [],
  } = orderDetails;

  // ✅ Total before round-off
  const totalBeforeRoundOff = total_amount - round_off;

  return (
    <div className="view-wrapper print-wrapper">
      {/* Success Message */}
      <div className="view-status print-status">
        <p className="view-success print-success">
          <span className="view-icon print-icon">
            <BsCheck />
          </span>{" "}
          Payment Successful
        </p>
      </div>

      {/* Receipt Card */}
      <div className="view-card print-card">
        <h2 className="view-stall print-stall">
          {order_details[0]?.stall_name || "Stall Name"}
        </h2>

        <p className="view-token print-token">
          Token No.: <strong>{tokenNo}</strong>
        </p>
        <p className="view-date print-date">GSTIN: 36AAVFN1793L1ZE</p>
        <p className="view-date print-date">Date: {createdAt}</p>

        <hr className="view-separator print-separator" />

        {/* Table */}
        <table className="view-table print-table">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Qty.</th>
              <th>Price (Rs)</th>
            </tr>
          </thead>
          <tbody>
            {order_details.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.quantity}</td>
                <td>{item.price.toFixed(2)}</td>
              </tr>
            ))}

            {/* Taxes */}
            <tr>
              <td>CGST</td>
              <td></td>
              <td>{cgst.toFixed(3)}</td>
            </tr>
            <tr>
              <td>SGST</td>
              <td></td>
              <td>{sgst.toFixed(3)}</td>
            </tr>
            <tr>
              <td>Total GST</td>
              <td></td>
              <td>{total_gst.toFixed(2)}</td>
            </tr>

            {/* Totals */}
            <tr>
              <td>Total (Rs)</td>
              <td></td>
              <td>{totalBeforeRoundOff.toFixed(2)}</td>
            </tr>
            <tr>
              <td>Round Off (Rs)</td>
              <td></td>
              <td>
                {round_off >= 0
                  ? `+ ${round_off.toFixed(2)}`
                  : `- ${Math.abs(round_off).toFixed(2)}`}
              </td>
            </tr>
            <tr className="view-grand print-grand">
              <td>
                <strong>Grand Total (Rs)</strong>
              </td>
              <td></td>
              <td>
                <strong>{total_amount.toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
